export default __webpack_public_path__ + "static/media/face.ab2412d9.png";